module.exports = __webpack_public_path__ + "static/media/finance-icon.d8571cca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/finance-icon.svg
// module id = 1917
// module chunks = 0